import rill from "rill";
import set from "@rill/set";
import isCoachEditing from "../../../middleware/is-coach-editing";
import CalendarSingleDay from "./calendar-single-day";
import CalendarWeek from "./calendar-week";
import CalendarMonth from "./calendar-month";
import ExerciseHistoryController from "../../athlete-portal/calendar/exercise-history-controller";
import SessionRpeController from "../../athlete-portal/calendar/session-rpe-controller";
import ReadinessRateController from "../../athlete-portal/calendar/readiness-rate-controller";
import ProgressPhotosController from "../../athlete-portal/calendar/progress-photos-controller";
import BodyMeasurementsController from "../../athlete-portal/calendar/body-measurements-controller";
import BodyweightController from "../../athlete-portal/calendar/bodyweight/bodyweight.controller";
import StepCountController from "../../athlete-portal/calendar/step-count/step-count.controller";
import SleepTimeController from "../../athlete-portal/calendar/sleep-time/sleep-time.controller";
import HrvController from "../../athlete-portal/calendar/hrv/hrv.controller";

const CalendarController = (app) => {
  app.at(
    "/calendar/*",
    isCoachEditing,
    rill()
      .use(set("heading", ["Calendar"]))
      .setup(CalendarSingleDay)
      .setup(CalendarWeek)
      .setup(CalendarMonth)
      .setup(ExerciseHistoryController)
      .setup(SessionRpeController)
      .setup(ReadinessRateController)
      .setup(ProgressPhotosController)
      .setup(BodyMeasurementsController)
      .setup(BodyweightController)
      .setup(StepCountController)
      .setup(SleepTimeController)
      .setup(HrvController)
  );
};

export default CalendarController;
